<template>
    <BasePanel
        headline='lang_AZ_PERSONS_PANEL_CAPTION_FINANCE'
        helpContext="AzPersonsEditPanelFinance"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <v-row class="pt-4">
                    <v-col>
                        <BaseEditPageTextarea 
                            :context="context"
                            field="PaymentOrder"
                            rows="3"
                            :label="$t('lang_GENERAL_CAPTION_PAYMENT_ORDER')"
                            :alvqa="alvqa + '-textarea-payment-order'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="AccountHolder"
                            :label="$t('lang_GENERIC_CAPTION_ACCOUNT_HOLDER')"
                            :alvqa="alvqa + '-textfield-account-holder'"
                        />
                    </v-col>
                    <!-- TODO: rule, only positive integers -->
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="PaymentTarget"
                            :label="$t('lang_GENERIC_CAPTION_PAYMENT_TARGET')"
                            :alvqa="alvqa + '-textfield-payment-target'"
                        />
                    </v-col>
                    <v-col>
                        <!--  TODO rule for ust-id -->
                        <BaseEditPageTextField 
                            :context="context"
                            field="VatId"
                            :label="$t('lang_GENERIC_CAPTION_VAT_ID')"
                            :alvqa="alvqa + '-textfield-vat-id'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Iban"
                            :label="$t('lang_GENERAL_CAPTION_IBAN_ACCOUNT_NO')"
                            :alvqa="alvqa + '-textfield-iban'"
                        />
                    </v-col>
                    <v-col cols="2">
                        <BaseEditPageTextField 
                            :context="context"
                            field="VatRetail"
                            :label="$t('lang_AZ_PERSONS_CAPTION_VAT_RETAIL')"
                            rules="percentDecimal"
                            :alvqa="alvqa + '-textfield-vat-retail'"
                        />
                    </v-col>
                    <v-col cols="2">
                        <BaseEditPageTextField 
                            :context="context"
                            field="VatLicense"
                            rules="percentDecimal"
                            :label="$t('lang_AZ_PERSONS_CAPTION_VAT_LICENSE')"
                            :alvqa="alvqa + '-textfield-vat-license'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxOffice"
                            :label="$t('lang_GENERAL_CAPTION_TAX_OFFICE')"
                            :alvqa="alvqa + '-textfield-tax-office'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Bic"
                            :label="$t('lang_GENERAL_CAPTION_BIC_SWIFT_ABA')"
                            :alvqa="alvqa + '-textfield-bic'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="RegistrationNumber"
                            :label="$t('lang_GENERAL_CAPTION_COMPANY_REGISTRATION_NO')"
                            :alvqa="alvqa + '-textfield-registration-number'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxNumber"
                            :label="$t('lang_GENERAL_CAPTION_TAX_NO')"
                            :alvqa="alvqa + '-textfield-tax-number'"
                            
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="BankName"
                            :label="$t('lang_GENERAL_CAPTION_BANK_NAME')"
                            :alvqa="alvqa + '-textfield-bank-name'"
                        />
                    </v-col>
                     <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="RegisterCourt"
                            :label="$t('lang_GENERAL_CAPTION_REGISTRATION_OFFICE')"
                            :alvqa="alvqa + '-textfield-register-court'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxIdNumber"
                            :label="$t('lang_GENERAL_CAPTION_TAX_ID_GERMAN')"
                            :alvqa="alvqa + '-textfield-tax-id-number'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="BankDataLocalized"
                            rules="bankDataLocalized"
                            :label="$t('lang_GENERIC_CAPTION_BANK_DATA_LOCALIZED')"
                            :alvqa="alvqa + '-textfield-bank-data-localized'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <BaseEditPageDropdown 
                            :context="context"
                            field="TaxWaiver"
                            :items="taxWaiverItems" 
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER')" 
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-tax-waiver'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="TaxWaiverFrom"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_FROM')"
                            :alvqa="alvqa + '-datepicker-tax-waiver-from'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="TaxWaiverTo"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_TO')"
                            :alvqa="alvqa + '-datepicker-tax-waiver-to'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxWithholdingPercentage"
                            :label="$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_TAX_PERCENTAGE')"
                            :rules="withholdingRules"
                            numberFormat="decimal3"
                            :iconTooltipText="$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_TAX_PERCENTAGE_HELP')"
                            :alvqa="alvqa + '-textfield-tax-withholding-percentage'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField
                            :context="context"
                            field="TaxWithholdingSurchargePercentage"
                            :label="$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_SURCHARGE_PERCENTAGE')"
                            rules="percentDecimal3"
                            numberFormat="decimal3"
                            :alvqa="alvqa + '-textfield-tax-withholding-surcharge-percentage'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxLiabilityPercentage"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_LIABILITY_PERCENTAGE')"
                            numberFormat="decimal3"
                            :alvqa="alvqa + '-textfield-tax-liability-percentage'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="RecoupmentPriority"
                            :items="recoupmentPriorityItems" 
                            :label="$t('lang_AZ_CAPTION_RECOUPMENT_PRIORITY')" 
                            :selection="true"
                            :clearable="false"
                            :alvqa="alvqa + '-dropdown-recoupment-priority'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="PublishingStatementsText"
                            :label="$t('lang_AZ_PERSONS_CAPTION_PUBLISHING_STATEMENTS_TEXT')"
                            :alvqa="alvqa + '-textfield-publishing-statements-text'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="LabelStatementsText"
                            :label="$t('lang_AZ_PERSONS_CAPTION_LABEL_STATEMENTS_TEXT')"
                            :alvqa="alvqa + '-textfield-label-statements-text'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import { DropdownAzRecoupmentPriority } from '@/assets/dropdowns/alvDropdowns'

export default {
    name: "FinancePanel",
    components: {
        BasePanel,
        BaseEditPageTextarea,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageDatePicker
    },
    data() {
        return {
            context: "AzPersonsFinance",
            alvqa: "az-persons-edit-form-panel-finance"
        }
    },
    computed: {
        taxWaiverItems() {
            return [
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_NOT_AVAILABLE'), 
                    value: "1",
                    alvqa: this.alvqa + '-dropdown-tax-waiver-not-available'
                },
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_AVAILABLE'), 
                    value: "2",
                    alvqa: this.alvqa + '-dropdown-tax-waiver-available'
                }
            ]
        },
        recoupmentPriorityItems() {
            return DropdownAzRecoupmentPriority.map(item => ({
                text: this.$t(item.text),
                value: item.value,
                alvqa: this.alvqa + '-dropdown-' + item.alvqa
            }))
        },
        taxWaiverValue() {
            return this.$store.getters.getAzPersonsFinanceDetailsTaxWaiver
        },
        withholdingRules() {
            return this.isTaxWaiverRequired(this.taxWaiverValue) ? 'percentDecimal3|required' : 'percentDecimal3'
        }
    },
    watch: {
        taxWaiverValue(newVal) {
            this.maybePrefillWithholding(newVal)
        }
    },
    mounted() {
        this.maybePrefillWithholding(this.taxWaiverValue)
    },
    methods: {
        isTaxWaiverRequired(waiver) {
            return waiver == 1 || waiver == '1' || waiver == 2 || waiver == '2'
        },
        maybePrefillWithholding(waiver) {
            if (!this.isTaxWaiverRequired(waiver)) return
            const country = String(this.$store.getters.getCompanyCountry || '').toUpperCase()
            const currency = String(this.$store.getters.getSelectedCurrency || '').toUpperCase()
            if ((country !== 'DEU' && country !== 'DE') || currency !== 'EUR') return
            const current = this.$store.getters.getAzPersonsFinanceDetailsTaxWithholdingPercentage
            const surcharge = this.$store.getters.getAzPersonsFinanceDetailsTaxWithholdingSurchargePercentage
            if (current !== null && current !== undefined && current !== '') return
            if (surcharge !== null && surcharge !== undefined && surcharge !== '') return
            this.$store.commit(
                'setAzPersonsFinanceDetailsTaxWithholdingPercentage',
                this.$alvPlugin.getNumberLocalization(15, 'decimal3')
            )
            this.$store.commit(
                'setAzPersonsFinanceDetailsTaxWithholdingSurchargePercentage',
                this.$alvPlugin.getNumberLocalization(0.825, 'decimal3')
            )
        }
    }
}
</script>